// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TopicPostAuthor_wrapper","separator":"TopicPostAuthor_separator","avatar":"TopicPostAuthor_avatar","name":"TopicPostAuthor_name"};